// Notification destinations are routing hints, never authorization or arbitrary redirects.
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function conversationPath(id) {
  if (id == null || id === '') return '/inbox';
  return typeof id === 'string' && uuid.test(id) ? `/inbox/${id.toLowerCase()}` : null;
}

export function inboxLoginHref(id) {
  return `#/about?inbox=${encodeURIComponent(conversationPath(id) || '/inbox')}&reauth=1`;
}

export function readInboxLogin(hash) {
  if (typeof hash !== 'string' || !hash.startsWith('#/about?')) return null;
  const query = new URLSearchParams(hash.slice('#/about?'.length));
  if (query.getAll('inbox').length !== 1) return null;
  const requested = query.get('inbox');
  const target = requested === '/inbox' ? '/inbox'
    : requested?.startsWith('/inbox/') ? conversationPath(requested.slice('/inbox/'.length)) : null;
  return target ? { target, forceLogin: query.get('reauth') === '1' } : null;
}
